<script setup>
import bg from '@/assets/img/hero/hero_bg.svg'
import bgMin from '@/assets/img/hero/hero_bg--min.svg'
import bgElem1 from '@/assets/img/hero/hero_bg-elem-1.png'
import bgElem2 from '@/assets/img/hero/hero_bg-elem-2.png'
import bgElem3 from '@/assets/img/hero/hero_bg-elem-3.png'
import bgElem4 from '@/assets/img/hero/hero_bg-elem-4.png'

const bgElems = [
	{ src: bgElem1, cx: 50, cy: 50, a: 100 },
	{ src: bgElem2, cx: 50, cy: 50, a: 100, dxr: true },
	{ src: bgElem3, cx: 50, cy: 50, a: 100, dyr: true },
	{ src: bgElem4, cx: 0, cy: 80, a: 80 },
]
</script>

<template>
	<section class="hero">
		<div class="hero__bg">
			<picture>
				<source :srcset="bg" media="(min-width: 991.98px)" />
				<img :src="bgMin" alt="" />
			</picture>
		</div>

		<div
			v-for="(image, index) in bgElems"
			:key="index"
			:class="`hero__bg-elem hero__bg-elem-${index + 1}`"
		>
			<img
				:src="image.src"
				alt=""
				v-parallax
				:data-prlx-cx="image.cx"
				:data-prlx-cy="image.cy"
				:data-prlx-a="image.a"
				:data-prlx-dxr="image.dxr ? '' : null"
				:data-prlx-dyr="image.dyr ? '' : null"
			/>
		</div>

		<div class="hero__text">
			<div class="hero__left">
				<div class="hero__layers">
					<div class="hero__layer hero__layer--background">
						<h2>
							<span>Управляем</span>
							<span>вниманием</span>
						</h2>
					</div>
					<div class="hero__layer hero__layer--foreground">
						<h1>
							<span>Управляем</span>
							<span>вниманием</span>
						</h1>
					</div>
				</div>
				<h3>Комплексные маркетинговые решения</h3>
			</div>

			<div class="hero__right">
				<div class="hero__right_body">
					<div class="hero__vertical">
						<h2>Более</h2>
					</div>

					<div class="hero__numbers">
						<div class="hero__number hero__number--foreground">
							<ul class="hero__number-list">
								<li>20</li>
								<li>20</li>
								<li>20</li>
								<li>20</li>
							</ul>
							<h2>лет</h2>
						</div>

						<div class="hero__number hero__number--background">
							<h2><span>20</span> <span>лет</span></h2>
						</div>
					</div>
				</div>

				<router-link :to="{ path: '/', hash: '#services' }" class="arrow-btn">
					<div class="arrow-btn__icon">
						<svg viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M83.9922 38.5461L59.829 62.9504L59.8297 62.9511L49.9996 72.8789L16.9922 39.541L26.8216 29.6133L50.2577 53.2833L74.4209 28.8789L83.9922 38.5461Z"
								fill="#F27699"
							/>
						</svg>
					</div>

					<svg
						class="arrow-btn__shadow"
						preserveAspectRatio="none"
						viewBox="0 0 130 126"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M10 126L0 116.308H120L130 126H10Z" fill="#818B8F" />
						<path
							d="M130 9.70376L120 0L120 116.308L130 126L130 9.70376Z"
							fill="#3A3E40"
						/>
					</svg>
				</router-link>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
.hero {
	height: 85rem;
	position: relative;
	margin-bottom: 6rem;
	overflow: hidden;

	@media (max-width: 991.98px) {
		height: 46.5rem;
		margin-bottom: 0;
	}

	// .hero__bg
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -10;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	// .hero__bg-elem
	&__bg-elem {
		position: absolute;
		will-change: transform;
		transition: transform 0.2s ease-out;
		pointer-events: none;

		@media (max-width: 991.98px) {
			z-index: 10;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&-1 {
			top: 5.9%;
			left: 39.2%;
			width: 32.2rem;
			height: 25.3rem;

			@media (max-width: 991.98px) {
				width: 9.4rem;
				height: 7.5rem;
				top: -2.5%;
				left: 68%;
			}
		}

		&-2 {
			width: 30rem;
			height: 30rem;
			bottom: 25.3%;
			left: 2.7%;

			@media (max-width: 991.98px) {
				width: 9rem;
				height: 9rem;
				bottom: 49.6%;
				left: 5.2%;
			}
		}

		&-3 {
			width: 18.9rem;
			height: 19rem;
			bottom: 17%;
			left: 25.9%;
			z-index: 2;

			@media (max-width: 991.98px) {
				width: 7.1rem;
				height: 7.1rem;
				bottom: 52%;
				left: 87%;
			}
		}

		&-4 {
			width: 35.9rem;
			height: 35.6rem;
			bottom: 1%;
			right: 9.2%;
			z-index: -1;

			&::before {
				content: '';
				position: absolute;
				z-index: -1;
				display: block;
				background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='246' height='515' viewBox='0 0 246 515' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='20' y='420' width='173' height='95' fill='%233A3E40'/%3e%3cpath d='M133.659 445.447L245.727 443.407L193.218 413.073H96.6581L133.659 445.447Z' fill='%23525252'/%3e%3cpath d='M132.66 38.4666L132.66 444.584L0.261917 432.829L39.6075 0.553223L132.66 38.4666Z' fill='%233A3E40'/%3e%3c/svg%3e ");
				background-repeat: no-repeat;
				background-position: left bottom;
				background-size: contain;
				width: 24.5rem;
				height: 515.4rem;
				z-index: 10;
				bottom: -2.8rem;
				left: -2.4rem;

				@media (max-width: 991.98px) {
					width: 5.7rem;
					height: 7.5rem;
					bottom: -1.7rem;
					left: -1rem;
					background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='57' height='75' viewBox='0 0 57 75' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='36' height='75' fill='%233A3E40'/%3e%3cpath d='M36 0V63L57 50.877V0H36Z' fill='%23747474'/%3e%3c/svg%3e ");
				}
			}

			@media (max-width: 991.98px) {
				width: 12.3rem;
				height: 12.8rem;
				bottom: 17.1%;
				right: 62.8%;
				z-index: -1;
			}
		}
	}

	// .hero__text
	&__text {
		padding-top: 19.4rem;
		display: flex;
		align-items: flex-start;
		gap: 4rem;
		position: relative;

		@media (max-width: 991.98px) {
			padding-top: 5.3rem;
			padding-left: 2rem;
			padding-right: 2rem;
			flex-direction: column;
			gap: 1rem;
		}

		h1,
		h2 {
			font-weight: 900;
			font-size: 9rem;
			// line-height: 9.7rem;
			line-height: 108%;
			text-transform: uppercase;
			white-space: nowrap;

			@media (max-width: 991.98px) {
				font-size: 3.2rem;
			}
		}
	}

	// .hero__left
	&__left {
		@media (min-width: 991.98px) {
			padding-top: 11.3rem;
		}

		h3 {
			text-align: right;
			max-width: 33rem;
			margin: 2.3rem -14.7rem 0 auto;
			font-weight: 400;
			font-size: 2.8rem;
			// line-height: 3rem;
			line-height: 107%;
			color: rgba(255, 255, 255, 0.8);

			@media (max-width: 991.98px) {
				font-size: 1.6rem;
				max-width: 15rem;
				position: absolute;
				right: 21.2rem;
				top: calc(100% - 3.9rem);
			}
		}
	}

	// .hero__layers
	&__layers {
		display: flex;

		@media (max-width: 991.98px) {
			gap: 1rem;
		}
	}

	// .hero__layer
	&__layer {
		position: relative;

		h1,
		h2 {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 1.2rem;

			@media (max-width: 991.98px) {
				gap: 0;
			}

			span {
				display: inline-block;
			}
		}
	}

	// .hero__layer--background
	&__layer--background {
		color: #494e50;

		@media (max-width: 991.98px) {
			color: #fff;
		}

		@media (min-width: 991.98px) {
			z-index: -1;
		}

		h1,
		h2 {
			span {
				@media (min-width: 991.98px) {
					&:first-child {
						margin-left: -46.2rem;
					}
					&:last-child {
						margin-left: -41rem;
					}
				}
			}
		}
	}

	// .hero__layer--foreground
	&__layer--foreground {
		color: #fff;

		@media (max-width: 991.98px) {
			color: #494e50;
		}

		@media (min-width: 991.98px) {
			z-index: 1;
		}

		h1,
		h2 {
			span {
				@media (min-width: 991.98px) {
					&:first-child {
						margin-left: 0rem;
					}
					&:last-child {
						margin-left: 20rem;
					}
				}

				@media (max-width: 991.98px) {
					&:first-child {
						margin-left: -0.8rem;
					}
				}
			}
		}
	}

	// .hero__right
	&__right {
		margin: -2.2rem 0rem 0rem -0.3rem;

		@media (max-width: 991.98px) {
			margin: 2.2rem 0rem 0rem 8.8rem;

			h2 {
				font-size: 4.2rem;
			}
		}

		&_body {
			display: flex;
			align-items: flex-start;
		}

		.arrow-btn {
			@media (min-width: 991.98px) {
				margin: 5.2rem 0 0 23.4rem;
			}

			@media (max-width: 991.98px) {
				position: absolute;
				bottom: -14rem;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}

	// .hero__vertical
	&__vertical {
		writing-mode: vertical-rl;
		color: #f06793;

		@media (min-width: 991.98px) {
			transform: rotate(180deg);
		}
	}

	// .hero__numbers
	&__numbers {
		display: flex;
		align-items: flex-start;
		margin-top: -0.6rem;
		margin-left: 1.1rem;
		gap: 21rem;

		@media (max-width: 991.98px) {
			align-items: flex-end;
			margin-left: 0.6rem;
			margin-top: 0.8rem;
			gap: 0;
		}
	}

	// .hero__number
	&__number {
		display: flex;
		gap: 2.1rem;

		@media (max-width: 991.98px) {
			align-items: flex-end;
			gap: 0;
		}
	}

	// .hero__number-list
	&__number-list {
		display: flex;
		flex-direction: column;

		li {
			font-weight: 900;
			font-size: 9rem;
			// line-height: 9.7rem;
			line-height: 108%;
			text-transform: uppercase;

			@media (min-width: 991.98px) {
				&:nth-child(1) {
					color: #f06793;
				}
				&:nth-child(2) {
					color: rgba(240, 103, 147, 0.6);
					font-size: 8rem;
				}
				&:nth-child(3) {
					color: rgba(240, 103, 147, 0.2);
					font-size: 7rem;
				}
				&:nth-child(4) {
					color: rgba(240, 103, 147, 0.1);
					font-size: 5rem;
				}

				&:not(:last-child) {
					margin-bottom: 0rem;
				}
			}

			@media (max-width: 991.98px) {
				font-weight: 600;
				font-size: 4.2rem;

				&:first-child {
					display: none;
				}

				&:nth-child(2) {
					color: #5e4750;
				}
				&:nth-child(3) {
					color: #a75772;
				}
				&:nth-child(4) {
					color: #f06793;
				}

				&:not(:last-child) {
					margin-bottom: -0.8rem;
				}
			}
		}
	}

	// .hero__number--foreground
	&__number--foreground {
		color: #f06793;
	}

	// .hero__number--background
	&__number--background {
		color: #494e50;

		h2 {
			display: flex;
			gap: 1rem;
		}
	}
}
</style>
